export const accordion = {
  MuiAccordion: {
    root: {
      "&$expanded": {
        margin: 0,
      },
    },
  },
};
